import { defineComponent as _defineComponent } from 'vue'
import { onMounted, ref, watch } from 'vue'
import { appName } from '../config.ts'
import { translate as t } from '@nextcloud/l10n'
import sanitzeSVG from '../util/sanitize-inline-svg.ts'
// import Console from '../util/console.ts'

// const COMPONENT_NAME = 'DynamicSvgIcon'
// const logger = new Console(COMPONENT_NAME)

// Something like the following:
//
// <svg xmlns="http://www.w3.org/2000/svg" width="61.25" height="61.25" viewBox="0 0 61.25 61.25">
// ...
// </svg>


export default /*#__PURE__*/_defineComponent({
  __name: 'DynamicSvgIcon',
  props: {
    size: { default: undefined },
    width: { default: undefined },
    height: { default: undefined },
    viewBox: { default: undefined },
    title: { default: undefined },
    data: null
  },
  emits: ['click'],
  setup(__props: any) {

const props = __props as { size: number, width: number, height: number, viewBox: [number, number, number, number], title: string, data: string };





const dummy = document.createElement('div')

const makeSVGElement = () => {

  dummy.innerHTML = sanitzeSVG(props.data)

  const svg = dummy.firstChild

  if (!(svg instanceof SVGSVGElement)) {
    throw new TypeError(
      t(appName, 'Provided data is not a valid SVG image: "{data}".', { data: props.data }),
    )
  }

  const width = props.size || props.width
  const height = props.size || props.height

  if (width !== undefined) {
    svg.width.baseVal.newValueSpecifiedUnits(SVGLength.SVG_LENGTHTYPE_NUMBER, width)
    // svg.width.animVal.newValueSpecifiedUnits(SVGLength.SVG_LENGTHTYPE_NUMBER, width)
    // logger.debug('ANIM WIDTH AFTER')
  }
  if (height !== undefined) {
    svg.height.baseVal.newValueSpecifiedUnits(SVGLength.SVG_LENGTHTYPE_NUMBER, height)
    // svg.height.animVal.newValueSpecifiedUnits(SVGLength.SVG_LENGTHTYPE_NUMBER, height)
  }
  if (props.viewBox !== undefined) {
    svg.viewBox.baseVal.x = props.viewBox[0]
    svg.viewBox.baseVal.y = props.viewBox[1]
    svg.viewBox.baseVal.width = props.viewBox[2]
    svg.viewBox.baseVal.height = props.viewBox[3]
  }
  if (props.title) {
    let titleElement = dummy.querySelector('svg title')
    if (!titleElement) {
      titleElement = document.createElementNS('http://www.w3.org/2000/svg', 'title')
      svg.append(titleElement)
    }
    titleElement.textContent = props.title
  }

  // logger.debug('SVG DOM ELEMENT', svg)

  return svg
}

const container = ref<HTMLDivElement|null>(null)

onMounted(() => {
  container.value!.replaceChildren(makeSVGElement())
})

watch(props, () => {
  if (container.value) {
    container.value!.replaceChildren(makeSVGElement())
  }
})

return { __sfc: true,props, dummy, makeSVGElement, container }
}

})